import axios from 'axios'
import {getApiUrls,getApiUpdateUrls} from "@/http/base.http";

export function getSensorType(payload) {
    const { env } = getApiUrls();
    return axios.post(`${env}sensor/type/get`, payload).then(res => {
        axios.defaults.baseURL = res.data
        return res.data
    })
}

export function addSensorType(payload) {
    const { env } = getApiUrls();
    return axios.post(`${env}sensor/type/add`,payload).then(res => {
        axios.defaults.baseURL = res.data
        return res.data
    })
}

export function getByIdSensorType(id) {
    const { env } = getApiUrls();
    return axios.get(`${env}sensor/type/detail/${id}`).then(res => {
        axios.defaults.baseURL = res.data
        return res.data
    })
}
export function updateSensorType(payload) {
    const {envU } = getApiUpdateUrls();
    return axios.put(`${envU}sensor/type/update`,payload).then(res => {
        axios.defaults.baseURL = res.data
        return res.data
    })
}

export function ddSensorSpec() {
    const { env } = getApiUrls();
    return axios.get(`${env}dropdown/sensor/spec/dde`).then(res => {
        axios.defaults.baseURL = res.data
        return res.data
    })
}
export function ddFlowrateUnit() {
    const { env } = getApiUrls();
    return axios.get(`${env}dropdown/flowrate/unit/dde`).then(res => {
        axios.defaults.baseURL = res.data
        return res.data
    })
}
export function ddTotalUnit() {
    const { env } = getApiUrls();
    return axios.get(`${env}dropdown/total/unit/dde`).then(res => {
        axios.defaults.baseURL = res.data
        return res.data
    })
}